import { render, staticRenderFns } from "./set-batch.vue?vue&type=template&id=5d986385&scoped=true"
import script from "./set-batch.vue?vue&type=script&lang=js"
export * from "./set-batch.vue?vue&type=script&lang=js"
import style0 from "./set-batch.vue?vue&type=style&index=0&id=5d986385&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d986385",
  null
  
)

export default component.exports